var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/RenderOption/RenderOption.tsx";
import { LongText } from '@gmini/ui-kit';
import { useHover } from '@gmini/utils';
import { FilterOptionLabel } from "./RenderOption.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-types
export var RenderOption = function RenderOption(_ref) {
  var renderOptionIcon = _ref.renderOptionIcon,
      option = _ref.option,
      getOptionLabel = _ref.getOptionLabel;

  var _useHover = useHover(),
      hover = _useHover.hover,
      onMouseLeave = _useHover.onMouseLeave,
      onMouseOver = _useHover.onMouseOver;

  return /*#__PURE__*/_jsxs(FilterOptionLabel, {
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver,
    children: [renderOptionIcon === null || renderOptionIcon === void 0 ? void 0 : renderOptionIcon(option, hover), /*#__PURE__*/_jsx(LongText, {
      partSize: 5,
      withoutRightText: true,
      zIndexTooltip: 100000,
      children: getOptionLabel(option)
    })]
  });
};